import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    listOrganizationImportSessions: build.query<
      ListOrganizationImportSessionsApiResponse,
      ListOrganizationImportSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/organizations/${queryArg.organizationId}/import-sessions`,
      }),
    }),
    mergeMultiplePatients: build.mutation<
      MergeMultiplePatientsApiResponse,
      MergeMultiplePatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/patients/merge-multiple`,
        method: "POST",
        body: queryArg.mergeMultiplePatientsRequest,
      }),
    }),
    deleteImportSession: build.mutation<
      DeleteImportSessionApiResponse,
      DeleteImportSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}`,
        method: "DELETE",
      }),
    }),
    getImportSessionStatus: build.query<
      GetImportSessionStatusApiResponse,
      GetImportSessionStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}`,
      }),
    }),
    exportImportResults: build.query<
      ExportImportResultsApiResponse,
      ExportImportResultsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/export`,
      }),
    }),
    importSelectedPatients: build.mutation<
      ImportSelectedPatientsApiResponse,
      ImportSelectedPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/import`,
        method: "POST",
        body: queryArg.extractedPatientsRequest,
      }),
    }),
    listImportOperations: build.query<
      ListImportOperationsApiResponse,
      ListImportOperationsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/import-operations`,
      }),
    }),
    getImportOperationStatus: build.query<
      GetImportOperationStatusApiResponse,
      GetImportOperationStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/import-operations/${queryArg.operationId}`,
      }),
    }),
    importUnmatchedPatients: build.mutation<
      ImportUnmatchedPatientsApiResponse,
      ImportUnmatchedPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/import-unmatched`,
        method: "POST",
        body: queryArg.importUnmatchedRequest,
      }),
    }),
    getMatchedPatients: build.query<
      GetMatchedPatientsApiResponse,
      GetMatchedPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/matched-patients`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          status: queryArg.status,
        },
      }),
    }),
    bulkUpdatePatientStatus: build.mutation<
      BulkUpdatePatientStatusApiResponse,
      BulkUpdatePatientStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/patients`,
        method: "PATCH",
        body: queryArg.bulkUpdateStatusRequest,
      }),
    }),
    rejectPatients: build.mutation<
      RejectPatientsApiResponse,
      RejectPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/sessions/${queryArg.sessionId}/reject`,
        method: "POST",
        body: queryArg.rejectPatientsRequest,
      }),
    }),
    uploadImportFile: build.mutation<
      UploadImportFileApiResponse,
      UploadImportFileApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/data-migration/upload`,
        method: "POST",
        body: queryArg.importUploadFormData,
      }),
    }),
    postV2ProviderDataMigrationPatientsDeduplicate: build.mutation<
      PostV2ProviderDataMigrationPatientsDeduplicateApiResponse,
      PostV2ProviderDataMigrationPatientsDeduplicateApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/patients/deduplicate`,
        method: "POST",
        body: queryArg.findDuplicatesRequest,
      }),
    }),
    postV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidates:
      build.mutation<
        PostV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidatesApiResponse,
        PostV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidatesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/provider/data-migration/patients/deduplicate/auto-merge-candidates`,
          method: "POST",
          body: queryArg.findAutoMergeCandidatesRequest,
        }),
      }),
    postV2ProviderDataMigrationPatientsDeduplicateBatchMerge: build.mutation<
      PostV2ProviderDataMigrationPatientsDeduplicateBatchMergeApiResponse,
      PostV2ProviderDataMigrationPatientsDeduplicateBatchMergeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/patients/deduplicate/batch-merge`,
        method: "POST",
        body: queryArg.batchMergeRequest,
      }),
    }),
    getV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobId: build.query<
      GetV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobIdApiResponse,
      GetV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/patients/deduplicate/batch-merge/${queryArg.jobId}`,
      }),
    }),
    postV2ProviderDataMigrationPatientsDeduplicateDismiss: build.mutation<
      PostV2ProviderDataMigrationPatientsDeduplicateDismissApiResponse,
      PostV2ProviderDataMigrationPatientsDeduplicateDismissApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/patients/deduplicate/dismiss`,
        method: "POST",
        body: queryArg.dismissDuplicateRequest,
      }),
    }),
    postV2ProviderDataMigrationPatientsDeduplicateMerge: build.mutation<
      PostV2ProviderDataMigrationPatientsDeduplicateMergeApiResponse,
      PostV2ProviderDataMigrationPatientsDeduplicateMergeApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/patients/deduplicate/merge`,
        method: "POST",
        body: queryArg.mergeGroupRequest,
      }),
    }),
    providerListImportSessions: build.query<
      ProviderListImportSessionsApiResponse,
      ProviderListImportSessionsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions`,
        params: {
          status_filter: queryArg.statusFilter,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    providerDeleteImportSession: build.mutation<
      ProviderDeleteImportSessionApiResponse,
      ProviderDeleteImportSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}`,
        method: "DELETE",
      }),
    }),
    providerGetImportSessionStatus: build.query<
      ProviderGetImportSessionStatusApiResponse,
      ProviderGetImportSessionStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}`,
      }),
    }),
    approveCsvImport: build.mutation<
      ApproveCsvImportApiResponse,
      ApproveCsvImportApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}/approve-import`,
        method: "POST",
      }),
    }),
    getExtractedPatientsForReview: build.query<
      GetExtractedPatientsForReviewApiResponse,
      GetExtractedPatientsForReviewApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}/extracted-patients`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    approveReviewWizard: build.mutation<
      ApproveReviewWizardApiResponse,
      ApproveReviewWizardApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}/review/approve`,
        method: "POST",
      }),
    }),
    getReviewPatients: build.query<
      GetReviewPatientsApiResponse,
      GetReviewPatientsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}/review/patients`,
        params: {
          phase: queryArg.phase,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
    }),
    getReviewSummary: build.query<
      GetReviewSummaryApiResponse,
      GetReviewSummaryApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/sessions/${queryArg.sessionId}/review/summary`,
      }),
    }),
    providerUploadImportFile: build.mutation<
      ProviderUploadImportFileApiResponse,
      ProviderUploadImportFileApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/data-migration/upload`,
        method: "POST",
        body: queryArg.importUploadFormData,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type ListOrganizationImportSessionsApiResponse =
  /** status 200 OK */ ImportSessionListResponse;
export type ListOrganizationImportSessionsApiArg = {
  organizationId: string;
};
export type MergeMultiplePatientsApiResponse =
  /** status 200 OK */ MergeMultiplePatientsResponse;
export type MergeMultiplePatientsApiArg = {
  mergeMultiplePatientsRequest: MergeMultiplePatientsRequest;
};
export type DeleteImportSessionApiResponse = unknown;
export type DeleteImportSessionApiArg = {
  sessionId: string;
};
export type GetImportSessionStatusApiResponse =
  /** status 200 OK */ ImportSessionStatusResponse2;
export type GetImportSessionStatusApiArg = {
  sessionId: string;
};
export type ExportImportResultsApiResponse =
  /** status 200 OK */ MigratedDataResponse;
export type ExportImportResultsApiArg = {
  sessionId: string;
};
export type ImportSelectedPatientsApiResponse =
  /** status 200 OK */ ExtractedPatientsResponse;
export type ImportSelectedPatientsApiArg = {
  sessionId: string;
  extractedPatientsRequest: ExtractedPatientsRequest;
};
export type ListImportOperationsApiResponse =
  /** status 200 OK */ ImportOperationListResponse;
export type ListImportOperationsApiArg = {
  sessionId: string;
};
export type GetImportOperationStatusApiResponse =
  /** status 200 OK */ ImportOperationStatusResponse2;
export type GetImportOperationStatusApiArg = {
  sessionId: string;
  operationId: string;
};
export type ImportUnmatchedPatientsApiResponse =
  /** status 200 OK */ ImportUnmatchedResponse;
export type ImportUnmatchedPatientsApiArg = {
  sessionId: string;
  importUnmatchedRequest: ImportUnmatchedRequest;
};
export type GetMatchedPatientsApiResponse =
  /** status 200 OK */ MatchedPatientsResponse;
export type GetMatchedPatientsApiArg = {
  sessionId: string;
  /** Maximum number of patients to return */
  limit?: number;
  /** Number of patients to skip for pagination */
  offset?: number;
  /** Filter by import status (e.g., 'NEW', 'MATCHED', 'IMPORTED') */
  status?: string | null;
};
export type BulkUpdatePatientStatusApiResponse =
  /** status 200 OK */ BulkUpdateStatusResponse;
export type BulkUpdatePatientStatusApiArg = {
  sessionId: string;
  bulkUpdateStatusRequest: BulkUpdateStatusRequest;
};
export type RejectPatientsApiResponse =
  /** status 200 OK */ RejectPatientsResponse;
export type RejectPatientsApiArg = {
  sessionId: string;
  rejectPatientsRequest: RejectPatientsRequest;
};
export type UploadImportFileApiResponse =
  /** status 200 OK */ ImportSessionCreateResponse;
export type UploadImportFileApiArg = {
  importUploadFormData: ImportUploadFormData;
};
export type PostV2ProviderDataMigrationPatientsDeduplicateApiResponse =
  /** status 200 OK */ FindDuplicatesResponse;
export type PostV2ProviderDataMigrationPatientsDeduplicateApiArg = {
  findDuplicatesRequest: FindDuplicatesRequest;
};
export type PostV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidatesApiResponse =
  /** status 200 OK */ FindAutoMergeCandidatesResponse;
export type PostV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidatesApiArg =
  {
    findAutoMergeCandidatesRequest: FindAutoMergeCandidatesRequest;
  };
export type PostV2ProviderDataMigrationPatientsDeduplicateBatchMergeApiResponse =
  /** status 202 Accepted */ BatchMergeAcceptedResponse;
export type PostV2ProviderDataMigrationPatientsDeduplicateBatchMergeApiArg = {
  batchMergeRequest: BatchMergeRequest;
};
export type GetV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobIdApiResponse =
  /** status 200 OK */ BatchMergeJobStatusResponse;
export type GetV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobIdApiArg =
  {
    jobId: string;
  };
export type PostV2ProviderDataMigrationPatientsDeduplicateDismissApiResponse =
  /** status 200 OK */ DismissDuplicateResponse;
export type PostV2ProviderDataMigrationPatientsDeduplicateDismissApiArg = {
  dismissDuplicateRequest: DismissDuplicateRequest;
};
export type PostV2ProviderDataMigrationPatientsDeduplicateMergeApiResponse =
  /** status 200 OK */ MergeGroupResponse;
export type PostV2ProviderDataMigrationPatientsDeduplicateMergeApiArg = {
  mergeGroupRequest: MergeGroupRequest;
};
export type ProviderListImportSessionsApiResponse =
  /** status 200 OK */ ImportSessionListResponse;
export type ProviderListImportSessionsApiArg = {
  /** Filter by status. Use 'active' for in-progress sessions, 'complete' for finished sessions, or a comma-separated list of raw status values. */
  statusFilter?: string | null;
  /** Maximum number of sessions to return */
  limit?: number;
  /** Number of sessions to skip for pagination */
  offset?: number;
};
export type ProviderDeleteImportSessionApiResponse = unknown;
export type ProviderDeleteImportSessionApiArg = {
  sessionId: string;
};
export type ProviderGetImportSessionStatusApiResponse =
  /** status 200 OK */ ImportSessionStatusResponse2;
export type ProviderGetImportSessionStatusApiArg = {
  sessionId: string;
};
export type ApproveCsvImportApiResponse =
  /** status 200 OK */ ApproveImportResponse;
export type ApproveCsvImportApiArg = {
  sessionId: string;
};
export type GetExtractedPatientsForReviewApiResponse =
  /** status 200 OK */ ExtractionReviewResponse;
export type GetExtractedPatientsForReviewApiArg = {
  sessionId: string;
  /** Maximum number of patients to return */
  limit?: number;
  /** Number of patients to skip for pagination */
  offset?: number;
};
export type ApproveReviewWizardApiResponse =
  /** status 200 OK */ ReviewApproveResponse;
export type ApproveReviewWizardApiArg = {
  sessionId: string;
};
export type GetReviewPatientsApiResponse =
  /** status 200 OK */ ReviewPatientsResponse;
export type GetReviewPatientsApiArg = {
  sessionId: string;
  /** Review phase: 'new_patients', 'matched_patients', or 'appointments' */
  phase: ReviewPhase2;
  /** Page size */
  limit?: number;
  /** Number of items to skip */
  offset?: number;
};
export type GetReviewSummaryApiResponse =
  /** status 200 OK */ ReviewSummaryResponse;
export type GetReviewSummaryApiArg = {
  sessionId: string;
};
export type ProviderUploadImportFileApiResponse =
  /** status 200 OK */ MigrationSessionCreateResponse;
export type ProviderUploadImportFileApiArg = {
  importUploadFormData: ImportUploadFormData;
};
export type ErrorMessage = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportSessionStatusResponse = {
  completed_at: string | null;
  created_at: string;
  error_messages: ErrorMessage[];
  failed_patients: number;
  file_type: string;
  initializer_user_id: string | null;
  new_patients: number;
  organization_id: string;
  processed_patients: number;
  progress_percentage: number;
  session_id: string;
  status: string;
  total_patients: number;
  updated_at: string;
};
export type ImportSessionListResponse = {
  /** Organization ID these sessions belong to */
  organization_id: string;
  sessions: ImportSessionStatusResponse[];
  /** Total number of sessions returned */
  total: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type ErrorMessage2 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type MergeMultiplePatientsResponse = {
  /** Number of existing patients soft-deleted */
  deleted_count?: number;
  /** List of merge errors */
  errors?: ErrorMessage2[];
  /** Number of merge operations that failed */
  failed_count?: number;
  /** Number of patients successfully merged */
  merged_count?: number;
  /** UUID of the target patient */
  target_patient_id: string;
};
export type ImportErrorResponse = {
  /** Additional error details */
  details?: {
    [key: string]: any;
  } | null;
  /** Error message */
  error: string;
  /** Session ID if available */
  session_id?: string | null;
};
export type MergeMultiplePatientsRequest = {
  /** Organization UUID for scoping */
  organization_id: string;
  /** List of existing patient UUIDs to merge and soft-delete */
  source_existing_patient_ids?: string[];
  /** List of extracted patient UUIDs to merge */
  source_extracted_patient_ids?: string[];
  /** Existing patient UUID to merge into (target) */
  target_patient_id: string;
};
export type ErrorMessage3 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportSessionStatusResponse2 = {
  completed_at: string | null;
  created_at: string;
  error_messages: ErrorMessage3[];
  failed_patients: number;
  file_type: string;
  initializer_user_id: string | null;
  new_patients: number;
  organization_id: string;
  processed_patients: number;
  progress_percentage: number;
  session_id: string;
  status: string;
  total_patients: number;
  updated_at: string;
};
export type Allergy = {
  /** Name or description of the allergen */
  allergen: string;
  /** Whether the allergy is currently active */
  isActive?: boolean;
  /** Additional notes about the allergy */
  notes?: string | null;
  /** Date when allergy was first identified */
  onset_date?: string | null;
  /** Type of allergic reaction (hives, anaphylaxis, rash, etc.) */
  reaction?: string | null;
  /** Severity level (mild, moderate, severe, life-threatening) */
  severity?: string | null;
};
export type Diagnosis = {
  /** ICD-10 or other diagnostic code */
  code?: string | null;
  /** Date diagnosis was resolved */
  end_date?: string | null;
  /** Whether the diagnosis is currently active */
  isActive?: boolean;
  /** Name/description of the diagnosis */
  name: string;
  /** Date of diagnosis onset */
  start_date?: string | null;
};
export type Medication = {
  /** Dosage amount per administration */
  dosage_amount?: string | null;
  /** Date medication was discontinued */
  end_date?: string | null;
  /** Drug formulation (tablet, capsule, etc.) */
  formulation?: string | null;
  /** Frequency of administration (BID, qd, etc.) */
  frequency?: string | null;
  /** Generic drug name */
  generic_name?: string | null;
  /** Medical indication for the medication */
  indication?: string | null;
  /** Whether the medication is currently active */
  isActive?: boolean;
  /** Brand or common name of the medication */
  name: string;
  /** Route of administration (oral, IV, etc.) */
  route_of_administration?: string | null;
  /** Date medication was started */
  start_date?: string | null;
  /** Medication strength (e.g., '10 mg') */
  strength?: string | null;
  /** Specific timing instructions (HS, with meals, etc.) */
  timing?: string | null;
};
export type Procedure = {
  /** Procedure code (CPT, SNOMED, etc.) */
  code?: string | null;
  /** Date the procedure was performed */
  date_performed?: string | null;
  /** Whether this is a surgical procedure */
  isSurgical?: boolean;
  /** Location where procedure was performed */
  location?: string | null;
  /** Name of the procedure */
  name: string;
  /** Additional notes about the procedure */
  notes?: string | null;
  /** Outcome or result of the procedure */
  outcome?: string | null;
  /** Provider who performed the procedure */
  provider?: string | null;
};
export type SocialHistoryItem = {
  /** Category (smoking, alcohol, exercise, occupation, etc.) */
  category: string;
  /** Detailed description */
  description?: string | null;
  /** Date when this ended (if applicable) */
  end_date?: string | null;
  /** Quantity or frequency (e.g., '1 pack/day', '2 drinks/week') */
  quantity?: string | null;
  /** Date when this began */
  start_date?: string | null;
  /** Current status (current, former, never, etc.) */
  status: string;
};
export type PatientClinicalData = {
  /** List of patient allergies */
  allergies?: Allergy[];
  /** List of patient diagnoses */
  diagnoses?: Diagnosis[];
  /** List of patient medications */
  medications?: Medication[];
  /** List of medical procedures */
  procedures?: Procedure[];
  /** Social history items */
  social_history?: SocialHistoryItem[];
};
export type EmergencyContact = {
  /** Contact email address */
  email?: string | null;
  /** Contact full name */
  name?: string | null;
  /** Phone number in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** Relationship to patient (spouse, parent, sibling, friend, etc.) */
  relationship?: string | null;
};
export type EncounterDocumentReference = {
  created_at?: string | null;
  encounter_document_id: string;
  status?: "pending" | "completed";
  title?: string | null;
  type: "text" | "recording" | "document" | "note";
};
export type JotDocReference = {
  created_at?: string | null;
  jotdoc_id?: string | null;
  status?: "pending" | "completed";
  task_id?: string | null;
  thread_id?: string | null;
  title?: string | null;
  type?: string | null;
};
export type Encounter = {
  admin_activity_log?: {
    [key: string]: any;
  }[];
  appointment_id?: string | null;
  attestations?: {
    [key: string]: any;
  } | null;
  cpt_codes?: string[];
  created_at?: string | null;
  encounter_id: string;
  encounter_type?: string | null;
  end_time?: string | null;
  icd10_codes?: string[];
  inputs?: EncounterDocumentReference[];
  modality?: ("in_person" | "video" | "audio") | null;
  modified_at?: string | null;
  note_id?: string | null;
  note_title?: string | null;
  organization_id?: string | null;
  outputs?: (EncounterDocumentReference | JotDocReference)[];
  patient_id?: string | null;
  place_of_service?: string | null;
  provider_id: string;
  scheduled_duration?: number | null;
  scheduled_for?: string | null;
  start_time?: string | null;
  status?: "pending" | "processing" | "completed";
  template_id?: string | null;
  transcripts_deleted?: boolean;
  updated_at?: string | null;
  working_billing_claim?: {
    [key: string]: any;
  } | null;
};
export type PatientAddress = {
  /** City name */
  city?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 (apartment, suite, etc.) */
  line2?: string | null;
  /** Optional landline/location phone in E.164 format (e.g., +12125551234) */
  phone?: string | null;
  /** State abbreviation (2 characters) */
  state?: string | null;
  /** ZIP code (5 or 9 digit format, e.g., 12345 or 12345-6789) */
  zip?: string | null;
};
export type InsuranceInfo = {
  /** Whether authorization signature is on file */
  authorization_on_file?: boolean | null;
  /** S3 or storage location of authorization document for audit trail */
  authorization_resource_location?: string | null;
  /** Group number */
  group_number?: string | null;
  /** Address of insured if different from patient */
  insured_address?: PatientAddress | null;
  /** Date of birth of insured if different from patient */
  insured_dob?: string | null;
  /** Name of insured if different from patient */
  insured_name?: string | null;
  /** Sex of insured if different from patient (Male/Female) */
  insured_sex?: string | null;
  /** Insurance payer identifier code */
  payer_id?: string | null;
  /** Insurance company name */
  payer_name?: string | null;
  /** Specific plan or program name */
  plan_name?: string | null;
  /** Policy or ID number */
  policy_number?: string | null;
  /** Patient's relationship to insured (self, spouse, child, other) */
  relationship_to_insured?: string | null;
};
export type Patient = {
  /** [DEPRECATED - Use primary_address] Patient's street address */
  address?: string | null;
  /** [DEPRECATED - Use primary_address] City of residence */
  city?: string | null;
  deleted_at?: string | null;
  /** Date of birth in YYYY-MM-DD format (e.g., 1990-01-15) */
  dob?: string | null;
  /** Insurance eligibility status or coverage details */
  eligibility?: string | null;
  /** Email address for patient communication */
  email?: string | null;
  /** Emergency contact information */
  emergency_contact?: EmergencyContact | null;
  /** Employment status (employed, unemployed, retired, student, etc.) */
  employment_status?: string | null;
  /** Patient's legal first name */
  first_name?: string | null;
  /** Patient's gender identity (male, female, other, non-binary) */
  gender?: string | null;
  /** External patient identifier or medical record number */
  identifier?: string | null;
  /** [DEPRECATED - Use primary_insurance] Insurance policy or member ID number */
  insurance_policy_number?: string | null;
  /** Patient's family name or surname */
  last_name?: string | null;
  latest_encounter?: Encounter | null;
  /** Patient's middle name or initial */
  middle_name?: string | null;
  /** Primary mobile phone in E.164 format (e.g., +12125551234) for calls/texts */
  mobile_phone?: string | null;
  /** Patient's occupation or job title */
  occupation?: string | null;
  /** Whether patient authorization signature is on file */
  patient_consent_on_file?: boolean | null;
  /** S3 or storage location of consent document for audit trail */
  patient_consent_resource_location?: string | null;
  patient_id: string;
  /** [DEPRECATED - Use primary_insurance] Insurance payer identifier code */
  payer_id?: string | null;
  /** [DEPRECATED - Use primary_insurance] Insurance company or payer name */
  payer_name?: string | null;
  /** [DEPRECATED - Use primary_insurance] Patient's relationship to insurance subscriber */
  payer_relationship?: string | null;
  /** [DEPRECATED - Use mobile_phone] Phone number */
  phone?: string | null;
  /** Patient's preferred name or nickname */
  preferred_name?: string | null;
  /** Primary residential address */
  primary_address?: PatientAddress | null;
  /** DEPRECATED - use PatientCoverage table */
  primary_insurance?: InsuranceInfo | null;
  /** Patient's preferred pronouns (he/him, she/her, they/them, etc.) */
  pronouns?: string | null;
  /** Patient's race or ethnicity */
  race?: string | null;
  /** Secondary/mailing address if different from primary */
  secondary_address?: PatientAddress | null;
  /** DEPRECATED - use PatientCoverage table */
  secondary_insurance?: InsuranceInfo | null;
  /** Patient's sex for medical records and claims (Male/Female) */
  sex?: string | null;
  /** [DEPRECATED - Use primary_address] US state as 2-letter code */
  state?: string | null;
  stripe_customer_id?: string | null;
  /** DEPRECATED - use PatientCoverage table */
  tertiary_insurance?: InsuranceInfo | null;
  updated_at?: string | null;
  /** [DEPRECATED - Use primary_address] ZIP or postal code */
  zip?: string | null;
};
export type MatchedPatientResult = {
  /** Confidence score of the match (0-100) */
  confidence: number;
  /** Complete patient data from main database */
  patient: Patient;
  /** Patient ID for reference */
  patient_id: string;
};
export type PatientImportStatus =
  | "extracted"
  | "new"
  | "matched"
  | "imported"
  | "merged"
  | "skipped"
  | "failed";
export type MigrationMetadata = {
  /** Migration session identifier */
  import_session_id: string;
  /** Status of this patient's import */
  import_status: PatientImportStatus;
  /** When the data was imported */
  imported_at: string;
  /** Original ID from source system */
  original_import_id?: string | null;
  /** Original source filename */
  source_file?: string | null;
};
export type MigratedPatient = {
  /** Clinical data (medications, diagnoses, etc.) */
  clinical_data?: PatientClinicalData | null;
  /** List of matched patients with full data and confidence scores */
  matched_patients?: MatchedPatientResult[] | null;
  /** Information about how/when this was migrated */
  migration_metadata?: MigrationMetadata | null;
  /** Patient demographics and basic info */
  patient: Patient;
};
export type MigratedDataResponse = {
  /** Number of patients returned */
  patient_count: number;
  /** List of migrated patient records */
  patients: MigratedPatient[];
  /** When this data was retrieved */
  retrieved_at: string;
  /** Migration session UUID */
  session_id: string;
};
export type ErrorMessage4 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ExtractedPatientsResponse = {
  /** List of import errors */
  errors?: ErrorMessage4[];
  /** Estimated duration for async operations */
  estimated_duration_seconds?: number | null;
  /** Number of patients that failed to import */
  failed_count?: number;
  /** Number of patients successfully imported (includes both new and updated) */
  imported_count?: number;
  /** Whether the import is processed asynchronously */
  is_async: boolean;
  /** UUID of the import operation */
  operation_id: string;
  /** Status of operation: 'processing' | 'completed' | 'failed' */
  operation_status: string;
  /** Import session UUID */
  session_id: string;
  /** Number of patients skipped */
  skipped_count?: number;
  /** Deprecated: Always 0. Use imported_count for total successful imports */
  updated_count?: number;
};
export type ExtractedPatientsRequest = {
  /** List of extracted patient UUIDs to import */
  patient_ids: string[];
  /** Whether to skip patients marked as duplicates */
  skip_duplicates?: boolean;
  /** Whether to update existing patient records */
  update_existing?: boolean;
};
export type ErrorMessage5 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportOperationStatusResponse = {
  /** When processing completed */
  completed_at?: string | null;
  /** When the operation was created */
  created_at: string;
  /** Detailed error information */
  error_details?: ErrorMessage5[];
  /** Estimated duration in seconds */
  estimated_duration_seconds?: number | null;
  /** UUID of the operation */
  operation_id: string;
  /** Type of operation: 'import_selected' | 'import_unmatched' | 'merge_patients' */
  operation_type: string;
  /** Progress percentage */
  progress_percentage?: number;
  /** Number of patients processed */
  progress_processed_count?: number;
  /** Total number of patients to process */
  progress_total_count?: number;
  /** Number of patients that failed to import */
  results_failed_count?: number;
  /** Number of patients successfully imported */
  results_imported_count?: number;
  /** Number of patients skipped */
  results_skipped_count?: number;
  /** UUID of the import session */
  session_id: string;
  /** When processing started */
  started_at?: string | null;
  /** Current status: 'pending' | 'processing' | 'completed' | 'failed' */
  status: string;
  /** When the operation was last updated */
  updated_at: string;
};
export type ImportOperationListResponse = {
  /** List of operations */
  operations: ImportOperationStatusResponse[];
  /** UUID of the import session */
  session_id: string;
  /** Total number of operations */
  total: number;
};
export type ErrorMessage6 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportOperationStatusResponse2 = {
  /** When processing completed */
  completed_at?: string | null;
  /** When the operation was created */
  created_at: string;
  /** Detailed error information */
  error_details?: ErrorMessage6[];
  /** Estimated duration in seconds */
  estimated_duration_seconds?: number | null;
  /** UUID of the operation */
  operation_id: string;
  /** Type of operation: 'import_selected' | 'import_unmatched' | 'merge_patients' */
  operation_type: string;
  /** Progress percentage */
  progress_percentage?: number;
  /** Number of patients processed */
  progress_processed_count?: number;
  /** Total number of patients to process */
  progress_total_count?: number;
  /** Number of patients that failed to import */
  results_failed_count?: number;
  /** Number of patients successfully imported */
  results_imported_count?: number;
  /** Number of patients skipped */
  results_skipped_count?: number;
  /** UUID of the import session */
  session_id: string;
  /** When processing started */
  started_at?: string | null;
  /** Current status: 'pending' | 'processing' | 'completed' | 'failed' */
  status: string;
  /** When the operation was last updated */
  updated_at: string;
};
export type ErrorMessage7 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type ImportUnmatchedResponse = {
  /** List of import errors */
  errors?: ErrorMessage7[];
  /** Estimated duration for async operations */
  estimated_duration_seconds?: number | null;
  /** Number of patients that failed to import */
  failed_count?: number;
  /** Number of patients successfully imported */
  imported_count?: number;
  /** Whether the import is processed asynchronously */
  is_async: boolean;
  /** UUID of the import operation */
  operation_id: string;
  /** Status of operation: 'processing' | 'completed' | 'failed' */
  operation_status: string;
  /** Import session UUID */
  session_id: string;
};
export type ImportUnmatchedRequest = {};
export type MatchedPatientInfo = {
  /** Confidence score (0-100) */
  confidence: number;
  /** Patient demographic data */
  patient_data?: {
    [key: string]: any;
  } | null;
  /** ID of the matched patient */
  patient_id: string;
};
export type MatchedPatientData = {
  /** Extracted patient UUID */
  extracted_patient_id: string;
  /** Import status */
  import_status: string;
  /** Decrypted extracted patient data */
  imported_patient_data?: {
    [key: string]: any;
  } | null;
  /** Fetched and decrypted best matched patient data from main database */
  matched_patient_data?: {
    [key: string]: any;
  } | null;
  /** ID of best matched patient in main database */
  matched_patient_id?: string | null;
  /** When matching was performed */
  matching_completed_at?: string | null;
  /** Confidence score of best match (0-100) */
  matching_confidence?: number | null;
  /** Original ID from source system */
  original_import_id?: string | null;
  /** All potential patient matches with confidence scores */
  potential_matches?: MatchedPatientInfo[] | null;
};
export type MatchedPatientsResponse = {
  /** Whether more patients exist beyond current page */
  has_more: boolean;
  /** Limit used for this request */
  limit: number;
  /** Number of patients with matches */
  matched_count: number;
  /** Number of patients not yet processed for matching */
  not_processed_count: number;
  /** Offset used for this request */
  offset: number;
  /** List of extracted patients with matching data */
  patients: MatchedPatientData[];
  /** Import session UUID */
  session_id: string;
  /** Total number of extracted patients */
  total_imported: number;
  /** Number of patients without matches */
  unmatched_count: number;
};
export type ErrorMessage8 = {
  /** Additional context about the error */
  context?: {
    [key: string]: any;
  } | null;
  /** Category of error (e.g., 'validation', 'parsing', 'processing') */
  error_type?: string | null;
  /** Error message text */
  message: string;
  /** When the error occurred */
  timestamp: string;
};
export type BulkUpdateStatusResponse = {
  /** List of update errors */
  errors?: ErrorMessage8[];
  /** Number that failed to update */
  failed_count: number;
  /** Import session UUID */
  session_id: string;
  /** Number of patients updated */
  updated_count: number;
};
export type BulkUpdateStatusRequest = {
  /** Action to take */
  action: string;
  /** List of extracted patient UUIDs */
  patient_ids: string[];
  /** Reason for status change */
  reason?: string | null;
};
export type RejectPatientsResponse = {
  /** Number that failed to reject */
  failed_count: number;
  /** Number of patients rejected */
  rejected_count: number;
  /** Import session UUID */
  session_id: string;
};
export type RejectPatientsRequest = {
  /** List of extracted patient UUIDs to reject */
  patient_ids: string[];
  /** Reason for rejection */
  reason?: string | null;
};
export type ImportSessionCreateResponse = {
  /** When the session was created */
  created_at: string;
  /** S3 location of uploaded file */
  file_location?: string | null;
  /** Success message */
  message: string;
  /** UUID of the import session */
  session_id: string;
  /** Current status of the import */
  status: string;
};
export type ImportUploadFormData = {
  /** UUID of the organization */
  organization_id: string;
};
export type PatientSummarySchema = {
  created_at: string;
  date_of_birth?: string | null;
  email?: string | null;
  first_name?: string | null;
  insurance_payer_id?: string | null;
  insurance_policy_number?: string | null;
  insurance_provider?: string | null;
  last_appointment?: string | null;
  last_name?: string | null;
  mobile_phone?: string | null;
  patient_id: string;
};
export type PatientGroupSchema = {
  /** Average matching confidence (0-100) */
  confidence: number;
  /** Deterministic hash of patient IDs */
  group_id: string;
  /** Why these were grouped together */
  match_reasons: string[];
  patients: PatientSummarySchema[];
};
export type FindDuplicatesResponse = {
  duplicate_groups: PatientGroupSchema[];
  grouping_completed_at: string;
  organization_id: string;
  total_duplicates_found: number;
  total_patients: number;
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type FindDuplicatesRequest = {
  /** Minimum confidence score (0-100) to consider a match */
  confidence_threshold?: number;
  /** Organization UUID to search within */
  organization_id: string;
};
export type PatientSummarySchema2 = {
  created_at: string;
  date_of_birth?: string | null;
  email?: string | null;
  first_name?: string | null;
  insurance_payer_id?: string | null;
  insurance_policy_number?: string | null;
  insurance_provider?: string | null;
  last_appointment?: string | null;
  last_name?: string | null;
  mobile_phone?: string | null;
  patient_id: string;
};
export type AutoMergeCandidateSchema = {
  /** Average matching confidence (0-100) */
  confidence: number;
  /** Fields to fill on primary from secondaries */
  demographic_overrides: {
    [key: string]: string;
  };
  /** Deterministic hash of patient IDs */
  group_id: string;
  /** Why these were grouped together */
  match_reasons: string[];
  patients: PatientSummarySchema2[];
  /** Patient ID recommended as the merge target */
  suggested_primary_id: string;
};
export type FindAutoMergeCandidatesResponse = {
  auto_merge_candidates: AutoMergeCandidateSchema[];
  completed_at: string;
  organization_id: string;
  skipped_groups: number;
  total_duplicate_groups: number;
  total_patients: number;
};
export type FindAutoMergeCandidatesRequest = {
  /** Minimum confidence score (0-100) to consider a match */
  confidence_threshold?: number;
  /** Organization UUID to search within */
  organization_id: string;
};
export type BatchMergeAcceptedResponse = {
  /** Job ID for polling status */
  job_id: string;
  /** Human-readable status message */
  message?: string;
  /** Initial job status */
  status?: string;
  /** Number of groups to merge */
  total_groups: number;
};
export type BatchMergeGroupInput = {
  /** Field-value pairs to override on the primary patient after merge */
  demographic_overrides?: {
    [key: string]: string | null;
  } | null;
  /** Group ID from auto-merge candidates */
  group_id: string;
  /** Patient IDs to merge into primary */
  patient_ids_to_merge: string[];
  /** Patient to keep as primary */
  primary_patient_id: string;
};
export type BatchMergeRequest = {
  /** List of groups to merge */
  groups: BatchMergeGroupInput[];
  /** Organization UUID for scoping */
  organization_id: string;
};
export type BatchMergeGroupResultSchema = {
  error_message?: string | null;
  group_id: string;
  merged_patient_ids?: string[];
  primary_patient_id?: string | null;
  success: boolean;
};
export type BatchMergeJobStatusResponse = {
  completed_at?: string | null;
  created_at?: string | null;
  error_message?: string | null;
  failed?: number;
  job_id: string;
  processed_groups?: number;
  results?: BatchMergeGroupResultSchema[];
  started_at?: string | null;
  /** pending, processing, completed, or failed */
  status: string;
  successful?: number;
  total_groups?: number;
};
export type DismissDuplicateResponse = {
  dismissed: boolean;
  pairs_dismissed: number;
  patient_ids: string[];
};
export type DismissDuplicateRequest = {
  /** Organization UUID for scoping */
  organization_id: string;
  /** List of patient IDs to mark as not duplicates of each other */
  patient_ids: string[];
};
export type MergeGroupResponse = {
  appointment_series_deduplicated?: number;
  appointment_series_updated?: number;
  appointments_deduplicated?: number;
  appointments_updated?: number;
  coverages_updated?: number;
  diagnoses_merged?: number;
  documents_updated?: number;
  encounters_updated?: number;
  error_message?: string | null;
  form_sessions_updated?: number;
  invoices_updated?: number;
  medications_merged?: number;
  merged_patient_ids: string[];
  modules_copied?: number;
  notes_updated?: number;
  primary_patient_id: string;
  slugs_updated?: number;
  success: boolean;
  test_results_merged?: number;
};
export type ModuleItemSelection = {
  /** Index in that patient's module array */
  item_index: number;
  /** Module short name: diagnoses, medications, allergies, etc. */
  module_name: string;
  /** Which patient the item comes from */
  source_patient_id: string;
};
export type MergeGroupRequest = {
  /** Map of coverage_order ('1', '2', '3') to patient_id whose coverage to keep. If None, automatic timestamp-based conflict resolution is used. */
  coverage_selections?: {
    [key: string]: string;
  } | null;
  /** Field-value pairs to override on the primary patient's demographics after merge. Supported fields: first_name, last_name, dob, email, mobile_phone. If None, primary patient's demographics are kept as-is. */
  demographic_overrides?: {
    [key: string]: string | null;
  } | null;
  /** Cherry-picked module items. None=all-or-nothing merge, []=skip modules, populated=selective */
  module_selections?: ModuleItemSelection[] | null;
  /** Organization UUID for scoping */
  organization_id: string;
  /** List of patient IDs to merge into primary */
  patient_ids_to_merge: string[];
  /** Group ID (hash) of the duplicate group being merged */
  patient_match_group: string;
  /** Patient to keep as primary */
  primary_patient_id: string;
};
export type ApproveImportResponse = {
  /** Number of patients that failed to import */
  failed_count?: number;
  /** Number of patients successfully imported */
  imported_count?: number;
  /** Result message */
  message: string;
  /** Import session UUID */
  session_id: string;
  /** Updated session status */
  status: string;
};
export type ExtractedPatientReviewItem = {
  /** Formatted address string */
  address?: string | null;
  /** Appointment duration in minutes */
  appointment_duration?: number | null;
  /** Appointment type / encounter type */
  appointment_encounter_type?: string | null;
  /** Provider name from the CSV (optional — appointments can be org-level) */
  appointment_provider_name?: string | null;
  /** Display name of the matched provider in the system, null if no match or no provider in CSV */
  appointment_resolved_provider?: string | null;
  /** Appointment start time (ISO format) */
  appointment_start_time?: string | null;
  /** City */
  city?: string | null;
  /** Date of birth */
  dob?: string | null;
  /** Email address */
  email?: string | null;
  /** Emergency contact name */
  emergency_contact_name?: string | null;
  /** Emergency contact phone */
  emergency_contact_phone?: string | null;
  /** Emergency contact relationship */
  emergency_contact_relationship?: string | null;
  /** UUID of the extracted patient */
  extracted_patient_id: string;
  /** Patient's first name */
  first_name?: string | null;
  /** Gender */
  gender?: string | null;
  /** Insurance group number */
  group_number?: string | null;
  /** Patient identifier / MRN */
  identifier?: string | null;
  /** Current import status */
  import_status: string;
  /** Insurance policy number */
  insurance_policy_number?: string | null;
  /** Patient's last name */
  last_name?: string | null;
  /** Confidence tier: 'exact' (>=90), 'high' (>=70), or 'partial' (>=50) */
  match_confidence?: string | null;
  /** Match status for enrichment sessions: 'matched', 'ambiguous', or 'unmatched' */
  match_status?: string | null;
  /** UUID of the best-matched existing patient */
  matched_patient_id?: string | null;
  /** Display name of the best-matched existing patient */
  matched_patient_name?: string | null;
  /** Patient's middle name */
  middle_name?: string | null;
  /** Mobile phone number */
  mobile_phone?: string | null;
  /** Payer ID */
  payer_id?: string | null;
  /** Insurance payer name */
  payer_name?: string | null;
  /** Patient's preferred name */
  preferred_name?: string | null;
  /** Preferred pronouns */
  pronouns?: string | null;
  /** Race */
  race?: string | null;
  /** Relationship to insured (self, spouse, child, other) */
  relationship_to_insured?: string | null;
  /** Biological sex */
  sex?: string | null;
  /** State */
  state?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type ExtractionReviewResponse = {
  /** Whether more patients exist beyond current page */
  has_more: boolean;
  /** Limit used for this request */
  limit: number;
  /** Offset used for this request */
  offset: number;
  /** Extracted patients for review */
  patients: ExtractedPatientReviewItem[];
  /** Import session UUID */
  session_id: string;
  /** Total number of extracted patients */
  total_count: number;
};
export type ImportSessionStatus =
  | "pending"
  | "processing"
  | "in_progress"
  | "extracting"
  | "matching"
  | "ready_for_review"
  | "awaiting_schema_confirmation"
  | "importing"
  | "completed"
  | "failed"
  | "cancelled";
export type ReviewApproveResponse = {
  /** Number of patients approved for import */
  approved_count: number;
  /** Import session UUID */
  session_id: string;
  /** Number of patients skipped (e.g. ambiguous) */
  skipped_count: number;
  /** Session status after approval */
  status: ImportSessionStatus;
};
export type NewPatientItem = {
  /** Formatted address string */
  address?: string | null;
  /** City */
  city?: string | null;
  /** Date of birth */
  dob?: string | null;
  /** Email address */
  email?: string | null;
  /** Emergency contact name */
  emergency_contact_name?: string | null;
  /** Emergency contact phone */
  emergency_contact_phone?: string | null;
  /** Emergency contact relationship */
  emergency_contact_relationship?: string | null;
  /** UUID of the extracted patient */
  extracted_patient_id: string;
  /** Patient's first name */
  first_name?: string | null;
  /** Gender */
  gender?: string | null;
  /** Insurance group number */
  group_number?: string | null;
  /** Patient identifier / MRN */
  identifier?: string | null;
  /** Insurance policy number */
  insurance_policy_number?: string | null;
  /** Patient's last name */
  last_name?: string | null;
  /** Patient's middle name */
  middle_name?: string | null;
  /** Mobile phone number */
  mobile_phone?: string | null;
  /** Payer ID */
  payer_id?: string | null;
  /** Insurance payer name */
  payer_name?: string | null;
  /** Patient's preferred name */
  preferred_name?: string | null;
  /** Preferred pronouns */
  pronouns?: string | null;
  /** Race */
  race?: string | null;
  /** Relationship to insured */
  relationship_to_insured?: string | null;
  /** Biological sex */
  sex?: string | null;
  /** State */
  state?: string | null;
  /** ZIP code */
  zip?: string | null;
};
export type MatchConfidenceTier = "exact" | "high" | "partial" | "low";
export type MatchedPatientItem = {
  /** Fields where existing is empty but incoming has a value */
  enrichment_fields?: string[];
  /** Current values for the same fields on the existing patient */
  existing: {
    [key: string]: any;
  };
  /** UUID of the extracted patient */
  extracted_patient_id: string;
  /** Enrichable fields from the CSV row */
  incoming: {
    [key: string]: any;
  };
  /** Confidence tier for the match */
  match_confidence: MatchConfidenceTier;
  /** UUID of the matched existing patient */
  matched_patient_id: string;
  /** Display name of the matched patient */
  matched_patient_name?: string | null;
};
export type AppointmentItem = {
  /** Appointment duration in minutes */
  appointment_duration?: number | null;
  /** Appointment type / encounter type */
  appointment_encounter_type?: string | null;
  /** Appointment start time (ISO format) */
  appointment_start_time?: string | null;
  /** UUID of the extracted patient */
  extracted_patient_id: string;
  /** Patient's first name */
  first_name?: string | null;
  /** Patient's last name */
  last_name?: string | null;
  /** 'matched', 'unmatched', or 'ambiguous' */
  match_status?: string | null;
  /** Display name of the resolved system provider. Null if the CSV provider name could not be matched to an org member. */
  provider_name?: string | null;
};
export type ReviewPhase = "new_patients" | "matched_patients" | "appointments";
export type ReviewPatientsResponse = {
  /** Whether more items exist beyond this page */
  has_more: boolean;
  /** Phase-specific item objects */
  items: (NewPatientItem | MatchedPatientItem | AppointmentItem)[];
  /** Page size used */
  limit: number;
  /** Offset used */
  offset: number;
  /** Review phase name */
  phase: ReviewPhase;
  /** Import session UUID */
  session_id: string;
  /** Total items in this phase */
  total_count: number;
};
export type ReviewPhase2 = "new_patients" | "matched_patients" | "appointments";
export type ReviewSummaryResponse = {
  /** Multi-match patients (skipped on import) */
  ambiguous_patients: number;
  /** Patients with appointment data */
  appointments: number;
  /** Single-match patients to enrich */
  matched_patients: number;
  /** Unmatched patients to create */
  new_patients: number;
  /** Import session UUID */
  session_id: string;
  /** Total extracted patients in session */
  total_records: number;
};
export type ImportSessionStatus2 =
  | "pending"
  | "processing"
  | "in_progress"
  | "extracting"
  | "matching"
  | "ready_for_review"
  | "awaiting_schema_confirmation"
  | "importing"
  | "completed"
  | "failed"
  | "cancelled";
export type MigrationSessionCreateResponse = {
  /** When the session was created */
  created_at: string;
  /** S3 location of uploaded file */
  file_location: string;
  /** Human-readable status message */
  message: string;
  /** Migration session UUID */
  session_id: string;
  /** Current session status */
  status: ImportSessionStatus2;
};
export type MigrationErrorResponse = {
  /** Additional error details */
  details?: {
    [key: string]: any;
  } | null;
  /** Error type or category */
  error: string;
  /** Related session ID if applicable */
  session_id?: string | null;
};
export const {
  useListOrganizationImportSessionsQuery,
  useMergeMultiplePatientsMutation,
  useDeleteImportSessionMutation,
  useGetImportSessionStatusQuery,
  useExportImportResultsQuery,
  useImportSelectedPatientsMutation,
  useListImportOperationsQuery,
  useGetImportOperationStatusQuery,
  useImportUnmatchedPatientsMutation,
  useGetMatchedPatientsQuery,
  useBulkUpdatePatientStatusMutation,
  useRejectPatientsMutation,
  useUploadImportFileMutation,
  usePostV2ProviderDataMigrationPatientsDeduplicateMutation,
  usePostV2ProviderDataMigrationPatientsDeduplicateAutoMergeCandidatesMutation,
  usePostV2ProviderDataMigrationPatientsDeduplicateBatchMergeMutation,
  useGetV2ProviderDataMigrationPatientsDeduplicateBatchMergeByJobIdQuery,
  usePostV2ProviderDataMigrationPatientsDeduplicateDismissMutation,
  usePostV2ProviderDataMigrationPatientsDeduplicateMergeMutation,
  useProviderListImportSessionsQuery,
  useProviderDeleteImportSessionMutation,
  useProviderGetImportSessionStatusQuery,
  useApproveCsvImportMutation,
  useGetExtractedPatientsForReviewQuery,
  useApproveReviewWizardMutation,
  useGetReviewPatientsQuery,
  useGetReviewSummaryQuery,
  useProviderUploadImportFileMutation,
} = injectedRtkApi;
